import { LitElement, html, nothing } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

class WishlistShareButton extends LitElement {
  static get properties() {
    return {
      count: { type: Number, state: true },
      loading: { type: Boolean, state: true },
      boardId: { type: Number, attribute: 'board-id' },
      shareUrl: { type: String, state: true },
    };
  }

  async connectedCallback() {
    super.connectedCallback();

    const wishlist = await window.wishlist.retrieve();
    this.count = wishlist.count;

    window.eventKeeper?.onEventHeard('wishlist:initialise', (detail) => {
      this.count = detail.count;
      this.loading = false;
      this.wishlist = detail;
    });

    document.addEventListener('wishlist:initialise', (event) => {
      this.count = event.detail.count;
      this.loading = false;
      this.wishlist = event.detail;
    });

    document.addEventListener('wishlist:update', (event) => {
      this.count = event.detail.count;
      this.loading = false;
      this.wishlist = event.detail;
    });

    document.addEventListener('wishlist:remove', (event) => {
      this.count = event.detail.count;
      this.loading = false;
      this.wishlist = event.detail;
    });

    document.addEventListener('wishlist:move-product', (event) => {
      this.count = event.detail.count;
      this.loading = false;
      this.wishlist = event.detail;
    });

    this.shareUrl = await window.wishlist.getShareUrl(this.boardId);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener('wishlist:move-product', (event) => {
      this.count = event.detail.count;
      this.loading = false;
      this.wishlist = event.detail;
    });

    document.removeEventListener('wishlist:update', (event) => {
      this.count = event.detail.count;
      this.loading = false;
      this.wishlist = event.detail;
    });

    document.addEventListener('wishlist:initialise', (event) => {
      this.count = event.detail.count;
      this.loading = false;
      this.wishlist = event.detail;
    });

    document.addEventListener('wishlist:remove', (event) => {
      this.count = event.detail.count;
      this.loading = false;
      this.wishlist = event.detail;
    });
  }

  async handleClick() {
    const mobile = window.matchMedia('(max-width: 768px)').matches;
    if (
      typeof window.navigator.share === 'function' &&
      this.shareUrl &&
      mobile
    ) {
      try {
        const shareData = {
          title: window.theme.strings.wishlist.share_title,
          text: window.theme.strings.wishlist.share_text,
          url: this.shareUrl,
        };
        await window.navigator.share(shareData);
      } catch (error) {
        console.error('Error sharing wishlist:', error);
      }
      return;
    }

    const modalShareEvent = new CustomEvent(`modal-wishlist-share:open`, {
      detail: { url: this.shareUrl, boardId: this.boardId },
    });
    document.dispatchEvent(modalShareEvent);
  }

  createRenderRoot() {
    return this;
  }

  render() {
    return html`${this.count > 0
      ? html`<button
          class="btn btn-primary"
          aria-haspopup="dialog"
          ?disabled=${this.loading}
          @click=${this.handleClick}
        >
          ${this.loading
            ? html`<bouncing-ellipsis></bouncing-ellipsis>`
            : html`<span
                >${unsafeHTML(window.theme.strings.wishlist.share)}
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.7914 12.6074C21.0355 12.3981 21.1575 12.2935 21.2023 12.169C21.2415 12.0598 21.2415 11.9402 21.2023 11.831C21.1575 11.7065 21.0355 11.6018 20.7914 11.3926L12.3206 4.13196C11.9004 3.77176 11.6903 3.59166 11.5124 3.58725C11.3578 3.58342 11.2101 3.65134 11.1124 3.77122C11 3.90915 11 4.18589 11 4.73936V9.03462C8.86532 9.40807 6.91159 10.4897 5.45971 12.1139C3.87682 13.8845 3.00123 16.1759 3 18.551V19.1629C4.04934 17.8989 5.35951 16.8765 6.84076 16.1659C8.1467 15.5394 9.55842 15.1683 11 15.0705V19.2606C11 19.8141 11 20.0908 11.1124 20.2288C11.2101 20.3486 11.3578 20.4166 11.5124 20.4127C11.6903 20.4083 11.9004 20.2282 12.3206 19.868L20.7914 12.6074Z"
                    stroke="currentColor"
                    stroke-width="1"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>`}
        </button>`
      : nothing}`;
  }
}

window.customElements.get('wishlist-share-button') ||
  window.customElements.define('wishlist-share-button', WishlistShareButton);
